import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'disDisabilityCertificateType'
})
export class DisDisabilityCertificateTypePipe implements PipeTransform {

  transform(value: number): string {
    return value == 0 ? 'Có' :( value == 2 ? 'Nghi ngờ' : 'Không');
  }

}
